import * as React from "react";
import { forwardRef, memo } from "react";
const SvgAe = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 6 3", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#00843D", d: "M0 0h6v3H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 1h6v2H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 2h6v1H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#C8102E", d: "M0 0h1.5v3H0z" }));
const ForwardRef = forwardRef(SvgAe);
const Memo = memo(ForwardRef);
export default Memo;
